import { render, staticRenderFns } from "./schoolClassManagementAdd.vue?vue&type=template&id=f3b6083a&scoped=true&"
import script from "./schoolClassManagementAdd.vue?vue&type=script&lang=js&"
export * from "./schoolClassManagementAdd.vue?vue&type=script&lang=js&"
import style0 from "./schoolClassManagementAdd.vue?vue&type=style&index=0&id=f3b6083a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b6083a",
  null
  
)

export default component.exports